import { render } from "./AddMagasinModal.vue?vue&type=template&id=3c207690&ts=true"
import script from "./AddMagasinModal.vue?vue&type=script&lang=ts"
export * from "./AddMagasinModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__